"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bemit;
function bemit(base, modifiers = []) {
  return [base].concat(modifiers.filter(str => str)).join(' ' + base + '--');
}
